import { jsonp, loadScript } from 'ThreeTerminal_base/base';
import { formatImage } from 'ThreeTerminal_base/publicMethod';

// apiUrl为webpack注入的全局变量
/* eslint-disable no-undef */
let apiBaseUrl = apiUrl;
/* eslint-enable no-undef */

if (typeof window === 'object' && /\.shank\.ifeng\.com/.test(window.location.hostname)) {
    apiBaseUrl = '/c';
}

const md5 = require('@ifeng-fe/md5');

const createJsonpCallbackName = (str, num) => {
    num = num ? num : 0;
    let jsonpCallbackName = `_${md5(`${str}_${num}`)}`;

    /* eslint-disable */
    while (typeof window === 'object' && window[jsonpCallbackName]) {
        /* eslint-enable */
        num++;
        jsonpCallbackName = `_${md5(`${str}_${num}`)}`;
    }

    return jsonpCallbackName;
};

// 获取幻灯评论数
export const getSlideCommentCount = async (url) => {
    const commentDomain = typeof window === 'object' && window.allData?.__cd__ ? window.allData.__cd__ : 'c01049em.ifeng.com';
    
    return await jsonp(`//${ commentDomain }/get.php`, {
        data: {
            docurl: url,
            job: 1,
            format: 'js',
        },
        jsonpCallback: 'getSlideCommentCount',
        cache: false,
    });
};

// 发送pc幻灯统计
export const requestTongji = async (datatype, value) => {
    const fa_param = window.getFaParams();
    const url = window.location.href;
    const time = new Date().getTime();
    const pt = 'hdtype=high';

    try {
        await loadScript('//stadig.ifeng.com/actsta.js', {
            data: {
                datatype,
                value: value ? value : '',
                uri: url,
                ref: '',
                uid: fa_param.uid ? decodeURIComponent(fa_param.uid) : '',
                sid: fa_param.sid ? decodeURIComponent(fa_param.sid) : '',
                time,
                ci: fa_param.ci ? decodeURIComponent(fa_param.ci) : '',
                pt: datatype === 'share' ? pt : '',
            },
            cache: false,
        });
    } catch (e) {
        console.error(e);
    }
};

// 幻灯 根据频道获取推荐图集
export const getRecommandSlides = async (searchPath, base62Id) => {
    const num = 15;
    let recommandData = [];
    const searchPathArr = [];

    searchPath
        .slice(0, searchPath.length - 1)
        .split('-')
        .forEach((item, index) => {
            if (searchPathArr.length === 0) {
                searchPathArr.push(`${item}-`);
            } else {
                searchPathArr.push(`${searchPathArr[index - 1]}${item}-`);
            }
        });

    // 数据不足时，先从跟栏目取数据
    for (let i = searchPathArr.length; i--; i === 0) {
        const data = await jsonp(`${apiBaseUrl}/api/slide/${searchPathArr[i]}/getRecommandSlides`, {
            jsonpCallback: 'getRecommandSlides',
            cache: false,
        });

        if (data.code === 0 && data.data && data.data.length > 0) {
            let slidesArr = [];
            const slides = data.data.filter((item) => item.base62Id !== base62Id);

            // 数据去重
            for (const item of slides) {
                const base62Id = item.base62Id;

                let flag = 0;

                for (const slide of recommandData) {
                    if (slide.base62Id === base62Id) {
                        flag = 1;
                    }
                }

                if (flag === 0) {
                    slidesArr.push(item);
                }
            }

            slidesArr = slidesArr.slice(0, num - recommandData.length).map((item) => ({
                base62Id: item.base62Id,
                url: item.url ? item.url : '',
                thumbnail:
                    item.thumbnails && item.thumbnails.image && item.thumbnails.image.length > 0
                        ? formatImage(item.thumbnails.image[0].url, 180, 122)
                        : '',
                title: item.title ? item.title : '',
            }));

            recommandData = recommandData.concat(slidesArr);
        }

        // console.log(recommandData);

        if (recommandData.length === num) {
            return recommandData;
        }
    }

    // 数据再不足时，再跟全站幻灯动态碎片取数据
    if (recommandData.length < num) {
        const data = await jsonp(`${apiBaseUrl}/api/client/topnewslist/getTopnewslist`, {
            jsonpCallback: 'getTopnewslist',
            cache: false,
        });

        if (data.code === 0 && data.data && data.data.length > 0) {
            let listArr = [];

            const list = data.data.filter(
                (item) =>
                    (item.status === 1 || item.status === '1') && item.type === 'slide' && item.base62Id !== base62Id,
            );

            // 数据去重
            for (const item of list) {
                const base62Id = item.base62Id;

                let flag = 0;

                for (const slide of [...recommandData]) {
                    if (slide.base62Id === base62Id) {
                        flag = 1;
                    }
                }

                if (flag === 0) {
                    listArr.push(item);
                }
            }

            listArr = listArr.slice(0, num - recommandData.length).map((item) => ({
                url: item.url ? item.url : '',
                thumbnail:
                    item.thumbnails && item.thumbnails.image && item.thumbnails.image.length > 0
                        ? formatImage(item.thumbnails.image[0].url, 180, 122)
                        : '',
                title: item.title ? item.title : '',
            }));

            console.log(listArr);

            recommandData = recommandData.concat(listArr);
        }
    }

    return recommandData;
};

// 幻灯 获取最后一帧图集推荐
export const getPicRecom = async (channel) => {
    const { schemaCheck } = await import('@ifeng-fe/container_content/common/client/services/validate');

    let data = await jsonp(`${apiBaseUrl}/api/content/graphic/slide/${channel}/callback`, {
        jsonpCallback: 'callback',
        cache: false,
    });
    const requestUrl = `${apiBaseUrl}/api/3/graphic/slide/${channel}`;

    data = schemaCheck(data.data, 'picRecomSchema', requestUrl);

    let picRecom = null;

    if (data) {
        picRecom = data.map((item) => ({
            url: item.url,
            title: item.title,
            img: item.img ? formatImage(item.img, 171, 103) : '',
            publishTime: item.publishTime,
        }));
    }

    return picRecom;
};

/**
 * 获取ucms图集相关推荐数据列表
 * @param {array} base64List
 */
export const getRelateFeedList = async (base64List = []) => {
    let result = [];

    if (base64List.length === 0) return result;
    const base64String = base64List.join(',');
    const getRelateFeedList = createJsonpCallbackName('getRelateFeedList');
    const data = await jsonp(
        `https://shankapi.ifeng.com/feedflow/getFeedflowListByUcmsIds/${base64String}/${getRelateFeedList}`,
        {
            jsonpCallback: getRelateFeedList,
            cache: false,
        },
    );

    if (data && data.code === 0 && data.data && data.data.length > 0) {
        result = data.data;
    }

    return result;
};
